<template>
 <RallyNav v-if="!this.$refs.RallyNav"/>
 <div>
  <div :class="[{ open: noSearchResultsFlag }, 'modal']">
      <div class="shadow" @click="closeModal"></div>
      <div class="body">
        <i class="fal fa-times exit" @click="closeModal"></i>
        <div class="heading">No Results</div>
        <div class="info">
          No search results found!
        </div>
        <div class="actions">
          <button class="secondary" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
    <UploadLimitModal ref="uploadLimitModalRef"/>

    <div v-if="checkReloadData">
      <main :class="mainClass">
        <input
            hidden
            ref="filePicker"
            type="file"
            multiple
            @change="onFileUpload"
            :accept="acceptedTypes"
        />
        <input
            hidden
            ref="imagePicker"
            type="file"
            multiple
            @change="onImageUpload"
            accept="image/*"
        />
        <ToolBar
            :back="back"
            :channelId="channelId"
            v-if="toolbarOptions"
            :options="toolbarOptions"
            :allow-status-filter="allowStatusFilter"
            :allow-my-contents-filter="allowMyContentsFilter"
            :my-contents-label="myContentsLabel"
            :channel-type="channelType"
            v-on:perform="perform"
        />
        <PhotoLightbox
            :channel="channel"
            :channelId="channelId"
            :rally="rally"
            :photo="currentPhoto"
            :photos="imageList"
            v-on:perform="perform"
        />
        <div style="padding-left:15px; padding-right:15px;">
          <div v-if="uploadQueueStatus.isProcessing" class="upload-progress-container">
            <div class="upload-progress-items">
              <div
                  v-for="upload in uploadQueueStatus.activeUploads"
                  :key="upload.id"
                  class="upload-progress-item"
              >
                <div class="upload-progress-bar-container">
                  <div
                      class="upload-progress-bar"
                      :style="`width: ${upload.progress || 0}%`"
                  >
                    <span class="upload-filename">{{ truncateFileName(upload.fileName) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="upload-status-text">
              Completed: {{uploadQueueStatus.completedFiles}} / Remaining: {{uploadQueueStatus.remainingFiles}}
            </div>
          </div>
          <div
              v-else-if="uploadCount > 0"
              id="progress-bar"
              class="progress-bar"
              :style="progressBarStyle"
          >
            <span>Uploading: {{this.uploadCount}}</span>
          </div>
        </div>
        <StandardContent
            v-if="currentContent"
            v-on:perform="perform"
            :channel="channel"
            :content="currentContent"
            :detailed="true"
            :id="currentContent.id"
            :contentType="currentContent.contentType"
            :observer="observer"
            :rally="rally"
            :parentContextId="contextId"
        />
        <section class="content-area" v-if="contentSearchResults && contentSearchResults.length > 0" ref="contentArea" >
          <StandardContent
              v-for="content in contentSearchResults"
              v-on:perform="perform"
              :channel="channel"
              :rally="rally"
              :content="content"
              :key="content.id"
              :parentContextId="contextId"
          />
        </section>
        <section v-if="this.noSearchResultsFlag">
          <br />
          <br />
          <br />
          <br />
          <h3 class="title" v-if="alertNoResults" style="text-align:center">No results!</h3>
        </section>
        <EmptyState v-if="isEmpty && !isChildContent" :channelType="channel.attributes.type" />
        <section
            class="content-area"
            v-if="!this.noSearchResultsFlag && (!contentSearchResults || contentSearchResults.length == 0)"
            :style="{ minHeight: '100vh' }"
            ref="contentArea"
        >


<StandardContent
      v-for="content in newContentFilter(filteredContents)"
      v-on:perform="perform"
      :channel="channel"
      :content="content"
      :contentId="content.id"
      :contentType="content.attributes['content-type']"
      :key="content.id"
      :parentContextIds="parentContextIds"
      :parentContextId="contextId"
      :observer="observer"
      :rally="rally"
  />


<draggable
  v-if="!noSearchResultsFlag"
  :list="container_list"
  item-key="id"
  :sort="false"
  :group="{ name: 'contents', pull: false, put: true }"
  @add="onAddToFolder"
  :disabled="isMobile || isNarrowScreen || !allowDraggableByChannel"
>
  <template #item="{ element }">
    <div class="container-tile" :data-content-id="element.id">
    <StandardContent
      v-on:perform="perform"
      :channel="channel"
      :rally="rally"
      :content="element"
      :contentId="element.id"
      :contentType="element.attributes['content-type']"
      :parentContextIds="parentContextIds"
      :parentContextId="contextId"
      :observer="observer"
      :key="element.id"
    />
    </div>
  </template>
</draggable>
<draggable
  v-if="!noSearchResultsFlag"
  :list="noncontainer_list"
  item-key="id"
  :sort="false"
  :group="{ name: 'contents',  pull: true, put: false }"
  @start="onSourceDragStart"
  :disabled="isMobile || isNarrowScreen || !allowDraggableByChannel"

>
  <template #item="{ element, index }">
    <StandardContent
      v-on:perform="perform"
      :channel="channel"
      :rally="rally"
      :content="element"
      :contentId="element.id"
      :contentType="element.attributes['content-type']"
      :parentContextIds="parentContextIds"
      :parentContextId="contextId"
      :observer="observer"
      :key="element.id"
    />
  </template>
</draggable>
          <infinite-loading
              ref="infLoad"
              @infinite="infiniteHandler" v-if="!isComplete"
              :distance="300"
              :key="paginationId"
              force-use-infinite-wrapper="body"
              :slots="{ complete: ' ' }"
          >   

          </infinite-loading>
          <div style="text-align: center; color: #999;">
                <i @click="reloadPage" class="fa fa-sync" style="cursor: pointer;">
                  <div style="font-family:sans-serif;">Refresh</div>
                </i>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from "vuex";
import {
  router,
  slugToTypeObjectMap,
  findDefaultChannelOfTypeForRally,
  findDefaultChannelObjOfType,
  kebabCase, channelTypeObjectMap, compareBy, getChannelSlug, ACCEPTED_FILE_TYPES, isMobile
} from "../common";
import { userInfo } from "../common/user-info";
import ContentMixin from "../components/ContentMixin";
import ContentReloadMixin from "../components/ContentReloadMixin";
import UploadLimitModal from "../components/UploadLimitModal.vue";
import { eventBus } from "../main.js";
import { uploadQueue } from "../common/upload-queue"; // Import the upload queue

export default {
  mixins: [
    ContentMixin,
    ContentReloadMixin
  ],
  components: {
    UploadLimitModal
  },
  data() {
    return {
      fileLimitUploads: false,
      currentPhoto: null,
      lastCount: 0,
      isComplete: false,
     // channelId: 0,
      //contextId: "0",
      //contextType: "Channel",
      loadAttempted: false,
      prevLoadCount: 0,
      prevLoadCountSameCount: 0,
      observer: null,
      pageMap: [],
      parentContainers: [],
      parentContextIds: [],
      parentContextTypes: [],
      rhWebParams: null,
      uploadProgress: 30,
      statusFilter: 1,
      drag: false,
      content_list: [],
      container_list: [],
      noncontainer_list: [],
      pre_draggable_container_list: [],
      draggedItem: null,
      hoveredContainer: null,
      isNarrowScreen: false,  
      uploadQueueStatus: {
        isProcessing: false,
        totalFiles: 0,
        completedFiles: 0,
        activeCount: 0,
        queueLength: 0,
        progress: 0,
        activeUploads: [],
        remainingFiles: 0
      },
      uploadProgressInterval: null,
      channelActions: {
        MessageWall: [
          {
            onClick: "newInline",
            params: { contentType: "WallMessage" },
            icon: "fa-plus-circle",
            label: "New Message",
            permission:"writable"
          },
          {
            onClick: "openSearch",
            params: { context:  "Message"},
            icon: "fa-search",
            label: "Search",
            permission:"readable"
          },
          {
            onClick: "openSettings",
            params: { context:  "Message"},
            icon: "fa-cog",
            label: "Settings",
            permission:"editable"
          }
        ],
        Files: [
          {
            onClick: "showFilez",
            params: { contentType: "File" },
            icon: "fa-plus-circle",
            label: "New File",
            permission:"writable"
          },
          {
            onClick: "newInline",
            params: { contentType: "Folder" },
            icon: "fa-folder",
            label: "New Folder",
            permission:"writable"
          },
          {
            onClick: "openSearch",
            params: { context:  "File"},
            icon: "fa-search",
            label: "Search",
            permission:"readable"
          },
          {
            onClick: "openSettings",
            params: { context:  "File"},
            icon: "fa-cog",
            label: "Settings",
            permission:"editable"
          }
        ],
        GivePayableGroup: [
          {
            onClick: "openRHWeb",
            params: { returnTo: 'fundraisers/new?fundraiser_type=GivePayableGroup',
              heading: 'Awesome, Looks Like You Are Ready to Create a Give page!',
              description: 'Please click the blue button to head to the mobile web app to get started.'},
            icon: "fa-plus-circle",
            label: "New Fundraiser",
            permission:"writable"
          }
        ],
        Links: [
          {
            onClick: "newInline",
            params: { contentType: "Link" },
            icon: "fa-plus-circle",
            label: "Add Link",
            permission:"writable"
          },
          {
            onClick: "newInline",
            params: { contentType: "Board" },
            icon: "fa-border-all",
            label: "New Board",
            permission:"writable"
          },
          {
            onClick: "openSettings",
            params: { context:  "Link"},
            icon: "fa-cog",
            label: "Settings",
            permission:"editable"
          }
        ],
        Gallery: [
          {
            onClick: "showImagez",
            params: { contentType: "Photo" },
            icon: "fa-plus-circle",
            label: "Add Photo",
            permission:"writable"
          },
          {
            onClick: "newInline",
            params: { contentType: "Album" },
            icon: "fa-book",
            label: "New Album",
            permission:"writable"
          },
          {
            onClick: "openSearch",
            params: { context:  "Photo"},
            icon: "fa-search",
            label: "Search",
            permission:"readable"
          },
          {
            onClick: "openSettings",
            params: { context:  "Photo"},
            icon: "fa-cog",
            label: "Settings",
            permission:"editable"
          }
        ],
        PayableGroup: [
          {
            onClick: "openRHWeb",
            params: { returnTo: 'fundraisers/new?fundraiser_type=PayableGroup',
              heading: 'Awesome, Looks Like You Are Ready to Create a Payment page!',
              description: 'Please click the blue button to head to the mobile web app to get started.'},
            icon: "fa-plus-circle",
            label: "New Payment",
            permission:"writable"
          }
        ],
        Signups: [
          {
            onClick: "newInline",
            params: { contentType: "SignupEvent" },
            icon: "fa-plus-circle",
            label: "New Sign-Up",
            hideAtTopLevel: true,
            permission:"writable"
          },
          {
            onClick: "newInline",
            params: { contentType: "SignupList" },
            icon: "fa-list-ul",
            label: "New List",
            permission:"writable"
          },
          {
            onClick: "openSettings",
            params: { context:  "SignupList"},
            icon: "fa-cog",
            label: "Settings",
            permission:"editable"
          },
          {
            onClick: "download",
            params: { context:  "SignupEvent"},
            icon: "fa-download",
            label: "Download",
            hideAtTopLevel: true,
            permission:"writable"
          }
        ],
        Fundraiser: [
          {
            onClick: "openRHWeb",
            params: { returnTo: 'fundraisers/new?fundraiser_type=PayableEvent',
              heading: 'Awesome, Looks Like You Are Ready to Create a Special Event!',
              description: 'Please click the blue button to head to the mobile web app to get started.'},
            icon: "fa-plus-circle",
            label: "New Event",
            permission:"writable"
          }
        ],
        Payables: [
          {
            onClick: "openRHWeb",
            params: { returnTo: 'fundraisers/new?fundraiser_type=PayableEvent',
              heading: 'Awesome, Looks Like You Are Ready to Create a Special Event!',
              description: 'Please click the blue button to head to the mobile web app to get started.'},
            icon: "fa-plus-circle",
            label: "New Event",
            permission:"writable"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("contents", ["contentById", "uploadCount", "allContentByContextTypeAndId", "resultCountByTypeAndId", "contentSearchResults", "noSearchResultsFlag", "maxPageByTypeAndId"]),
    ...mapState("rallies", ["rallyChannelsByRallyId", "allRalliesByRallyId"]),

    
    selectedRally() {
      return this.allRalliesByRallyId[parseInt(this.$route.params.rallyId)];
    },
    myRole() {
      return this.selectedRally.membership ? this.selectedRally.membership.attributes["role"] : "Friend";
    },
    isAdmin() {
      return this.myRole === "Admin" || this.myRole === "Owner";
    },

    paginationId(){
       //alert( "infinite-" +  this.contextId + "." +this.$route.path.split('/').length )
       return "infinite-" +  this.contextId + "." +this.$route.path.split('/').length 
    },
    contextId(){
      if (this.$route.path.indexOf("/c/") > 0){
        const segments = this.$route.path.split('/').filter(Boolean)
        return  segments[segments.length - 1]
      } else {
        return this.channelId
      }
    },

    parentContextId(){
      if (this.$route.path.indexOf("/c/") > 0){
        const segments = this.$route.path.split('/').filter(Boolean)
        if (segments.length >= 2){
          return  segments[segments.length - 2]
        } else {
          return this.channelId
        }
      } else {
        return this.channelId
      }
    },
    contextType(){
      if (this.$route.path.indexOf("/c/") < 0){
        return "Channel"
       } else {
        return "Container"
      }
    },
    parentContextType(){
      if (this.$route.path.indexOf("/c/") < 0){
        return "Channel"
       } else {
        const segments = this.$route.path.split('/').filter(Boolean)
        if (segments.length >= 2){
           return "Container"
        } else {
          return "Channel"
        }
        
      }
    },
    rallyId(){
     /* if (this.$route.params.prefix){
      const prefix = this.$route.params.prefix
      const segments = Array.isArray(prefix) ? prefix : [prefix]
      return segments[0]
      } else {*/
        return this.$route.params.rallyId
     // }
    },
    rally(){
      return this.allRalliesByRallyId[this.rallyId]
    },
    acceptedTypes() {
      return ACCEPTED_FILE_TYPES;
    },
    allowDraggableByChannel() {
      if (["Gallery", "Link", "Links", "File", "Files"].includes(this.channelType)) {
        return true;
      } else {
        return false;
      }
    },
    allowMyContentsFilter() {
      if (["Payables", "PayableGroup", "GivePayableGroup"].includes(this.channelType)) {
        return true;
      } else {
        return false;
      }
    },
    allowStatusFilter() {
      if (["Payables", "PayableGroup", "GivePayableGroup", "Signups"].includes(this.channelType)) {
        return true;
      } else {
        return false;
      }
    },
    channel() {
      console.log(this.rallyChannelsByRallyId[this.rallyId])
      //console.log(this.channelSlug)
      const chans = this.rallyChannelsByRallyId[this.rallyId]
      const chan = chans?.find(item => (item.attributes.slug.indexOf(this.channelSlug) >= 0))
      console.log("chan..." + this.channelSlug)
      console.log(chan) 
      return chan
    },
    channelId(){
      return this.channel?.id
    },
    myContentsLabel() {
      if (this.channelType == "Payables") {
        return "My Events"
      } else if (this.channelType == "PayableGroup") {
        return "My Payments"
      } else if (this.channelType == "GivePayableGroup") {
        return "My Donations"
      } else { 
        return ""
      }
    },
    openRhWebUniqueId(){
      return  this.rallyId + this.channelSlug
    },
    latestRhWebParams() {
      return this.rhWebParams
    },
    checkReloadData() {
      if ((!this.contents || this.contents.length == 0) && !this.loadAttempted) {
        return false
      }
      return true;
    },
    totalCount(){
      return this.resultCountByTypeAndId[this.contextId] ? this.resultCountByTypeAndId[this.contextId] : 0
    },
    isLoadingComplete(){
      return ((this.contents &&  this.contents.length >= this.totalCount-1 ) || this.prevLoadCountSameCount >= 2)
    },
    imageList() {
      if (this.contents && this.contents.length > 0) {
        return this.contents
            .map(a => {
              if (a.attributes["original-url"]) {
                return a;
              } else {
                return null;
              }
            })
            .filter(a => {
              if (a) {
                return a;
              }
            });
      } else {
        return [];
      }
    },
   // rallyId() {
     // return parseInt(this.$route.params.rallyId);
    //},
    back() {
      // Determine whether or not to display the "back" arrow in the toolbar.
      //return this.parentContextIds && this.parentContextIds.length > 0 ? "navUp" : "";
      return (this.$route.path.indexOf("/c/") > 0) ? "navUp" : ""
    },
    channelSlug() {
      return getChannelSlug(this.$route)
    },
    channelType() {
      return this.channel?.attributes.type
    },
    folderStructure() {
      return this.$store.getters['contents/folderStructureByChannel'](this.channelId);
    },
    channelTypePlural() {
      return channelTypeObjectMap()[this.channelType].channelTypePlural;
    },
    contentType() {
      return channelTypeObjectMap()[this.channelType]?.contentType
    },
    subContentType() {
      return channelTypeObjectMap()[this.channelType]?.type; 
    },
    currentContent() {
      return  this.contextType == "Container" ? this.contentById[this.contextId] : null//this.parentContainers ? this.parentContainers[this.parentContainers.length - 1]: null
    },
    mainClass() {
      return kebabCase(this.channelSlug) + " index";
    },
    myType() {
      return channelTypeObjectMap()[this.channelType].type;
    },
    newAction() {
      return channelTypeObjectMap()[this.channelType].newAction;
    },
    progressBarStyle() {
      if (this.uploadQueueStatus.isProcessing) {
        return "width: " + this.uploadQueueStatus.progress + "%;";
      } else if ( this.uploadCount == 0 ) {
        return 'display: none;';
      } else {
        return "width: " + this.uploadProgress + "%;upload-count:" + this.uploadCount;
      }
    },
    contents() {
      return this.allContentByContextTypeAndId[parseInt(this.contextId ? this.contextId : this.channelId)];
    },
    filteredContainers(){
      const cs = this.filteredContents;
      if (cs && cs.length > 0){
        return cs.filter(function(s) {
          return (s.attributes && (s.attributes.type == "Board" || s.attributes.type == "Folder" || s.attributes.type == "Album"))
        })
      } else {
        return []
      } 
    },
    filteredNonContainers(){
      const cs = this.filteredContents;
      if (cs && cs.length > 0){
        return cs.filter(function(s) {
          return (s.attributes && ( s.attributes.type != "WallMessage" && s.attributes.type != "Board" && s.attributes.type != "Folder" && s.attributes.type != "Album" ))
        })
      } else {
        return []
      } 
    },

    filteredContents(){
      const cs = this.contents;
      if (cs && cs.length > 0){
        return cs.filter(function(s) {
          return !(s.attributes && s.attributes.title && s.attributes.title.indexOf('[untitled]') >= 0 ) &&
              (s.attributes['status'] == 1 ||
                  s.attributes['status'] == 2 ||
                  s.attributes['status'] == 0 ||
                  s.editMode == true || s.attributes['lifecycle'] == "new")
        })
      } else {
        return []
      }
    },
    isEmpty() {
      return this.filteredContents && this.filteredContents.length == 0
    },
    isChildContent() {
      return (this.$route.path.indexOf("/c/") > 0)
      //return (this.parentContainers && this.parentContainers.length > 0)
    },
    toolbarOptions() {
      let options = new Array();
      if (
          this.rallyChannelsByRallyId &&
          this.rallyChannelsByRallyId[this.rallyId]
      ) {
        var chanObj = findDefaultChannelObjOfType(
            this.channelTypePlural,
            this.rallyChannelsByRallyId[this.rallyId]
        );
        for (let button of this.channelActions[this.channelType]) {
          if (button.permission === "readable"){
            options.push(button);
          }
          else if (chanObj.attributes['members-write'] === 'members' || (chanObj.attributes['members-write'] === 'admin' && this.isAdmin)){
            options.push(button);
          }
        }
        if (["Files", "Links", "Gallery"].includes(this.channelType)) {
          // Additional options can be added here
        }
      }
      return options;
    },
    contentParams() {
      //alert(this.rallyId +  this.contextId + this.channelId + this.contextType + this.subContentType)
      var cp = {
        contextRallyId: this.rallyId,
        rallyId: this.rallyId,
        contextType: this.contextType,//"Channel",
        contextChannelId: this.channelId,
        contextId: this.contextId ? this.contextId : this.channelId,
        contentType: this.contentType,
        include: ["shares", "attachments"],
        status: parseInt(this.statusFilter),
        customPageSize: ["Files", "Links", "Gallery", "Payables", "Signups"].includes(this.channelType) ? 15 : 10
      };
      return cp; 
    }
  },
  async created() {
    console.log("created!!")
    // I don't think this is needed any more as the rally should be loaded by RallyPage before we ever get here now.
    await this.fetchRalliesWithInfo({rallyId: this.rallyId});
    let myRally = this.allRalliesByRallyId[this.rallyId] 
    // TODO figure out logic to redirect to rallies page if not standard
    /*if  ((myRally?.rally?.attributes['rally-type'] !== 'Standard' && myRally?.rally?.attributes['rally-type'] !== null &&
        myRally?.rally?.attributes['rally-type'] !== undefined) ||
        (myRally?.attributes['rally-type'] !== 'Standard' && myRally?.attributes['rally-type'] !== null &&
            myRally?.attributes['rally-type'] !== undefined))

    {
      router.push({ path: '/rallies' })
    }*/
   // if (!this.channelId){
      //this.clearContentByContextId({contextId: this.channelId})
      //alert("loading")

      await this.loadPageData()
      console.log("loadcontents")
      await this.loadContents()
      this.content_list = this.sortedContents(this.filteredContents)
      this.noncontainer_list = this.sortedContents(this.filteredNonContainers)
      this.container_list = this.sortedContents(this.filteredContainers)
      //this.openContainer(this.contextId)
    //}
    //this.contextId = this.channelIlocal
    /*this.observer = new IntersectionObserver(
        this.onElementObserved,
        {
          root: this.$el,
          threshold: 1.0,
        }
    );*/
    this.clearContentSearchResults({})
    window.scrollTo(0, 0);
    eventBus.on('navUp', () => {
      this.navUp();
    })
    eventBus.on('lightboxHide', () => {
      this.handleLightboxHide();
    });
    this.startUploadProgressMonitoring();
    this.$nextTick(() => {
      if (this.channelId && !this.contents) {
        this.prevLoadCount = 0;
        this.prevLoadCountSameCount = 0;
        this.clearContentByContextId({ contextId: this.channelId });
        this.loadPageData();
      }
    });
  },
  mounted() {
    console.log('StandardContentIndex mounted');
    this.debugFolderFetch();
    // Fetch folder structure after component is mounted
    if (this.channelType === 'Files' && this.channelId) {
      console.log('Fetching folder structure for Files channel:', this.channelId);
      this.fetchFolderStructureForChannel();
    }
    this.sentimentObserver = new IntersectionObserver(
        (entries) => {
          const visibleShareIds = entries
              .filter(entry => entry.isIntersecting)
              .map(entry => {
                const content = this.contentById[entry.target.id];
                return content?.relationships?.['context-share']?.data?.id;
              })
              .filter(Boolean);

          if (visibleShareIds.length > 0) {
            this.fetchContentsLikeCounts({ shareIds: visibleShareIds });
          }
        },
        { rootMargin: '50px' }
    );

    // --- detect responsive vs full screen via width breakpoint ---
    // Use the same breakpoint as your CSS (e.g. 768px, 1024px, etc.)
    const mq = window.matchMedia('(max-width: 768px)');

    const handleMqChange = (e) => {
      this.isNarrowScreen = e.matches; // true when <= 768px (responsive)
    };

    // initial value
    handleMqChange(mq);

    // listen for resize changes
    mq.addEventListener('change', handleMqChange);

    // store for cleanup
    this._mq = mq;
    this._mqHandler = handleMqChange;
  },
  beforeDestroy() {
    if (this.uploadProgressInterval) {
      clearInterval(this.uploadProgressInterval);
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.channelSlug !== from.params.channelSlug || to.params.rallyId !== from.params.rallyId) {
        if (this.channelId){
          this.prevLoadCount = 0
          this.prevLoadCountSameCount= 0
          this.clearContentByContextId({contextId: this.channelId})

          // Clear folder structure cache when changing channels
          if (this.channelType === 'Files') {
            this.clearFolderStructureCache({ channelId: this.channelId });
          }
        }
        this.loadPageData();
      }
    },
    channelType(newType, oldType) {
      if (newType === 'Files' && newType !== oldType && this.channelId) {
        console.log('Channel type changed to Files, fetching folder structure');
        this.fetchFolderStructureForChannel();
      }
    },
    rallyChannelsByRallyId: function(newById, oldById) {
      if (!this.channelId && !this.loadAttempted) {
        this.loadContents();
      }
    },
    filteredContents: {
      handler(newContents, oldContents) {
        // keep lists in sync
        this.refreshLocalListsFromFiltered();
        // When contents change, trigger batch fetch
        if (newContents && newContents.length > 0) {
          // Use a small delay to ensure DOM is updated
          this.$nextTick(() => {
            setTimeout(() => {
              this.triggerBatchSentimentFetch();
            }, 100);
          });
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("contents", [
      "fetchContents",
      "fetchContentById",
      "uploadFile",
      "createContents",
      "uploadFileMultipart",
      "updateContent",
      "clearContentSearchResults",
      "setNoSearchResultsFlag",
      "clearContentByContextId",
      "fetchFoldersRecursive",
      "clearFolderStructureCache",
      "moveContent"
    ]),
    ...mapActions("rallies", ["fetchRalliesWithInfo", "fetchRalliesChannels"]),
    ...mapActions("user", ["fetchUsersById"]),
    ...mapActions("memberships", ["fetchMembersByRally"]),
    ...mapActions("activities", ["contentViewed"]),
    ...mapActions("sentiments", ["fetchContentsLikeCounts"]),

    refreshLocalListsFromFiltered() {
      // full list
      this.content_list = this.sortedContents(this.filteredContents); 

      // dependent lists
      this.container_list =  this.notNewContentFilter(this.sortedContents(this.filteredContainers));
      this.noncontainer_list = this.notNewContentFilter(this.sortedContents(this.filteredNonContainers));
    },
    onContainerMove(evt) {
      // vuedraggable passes extended info:
      // evt.relatedContext?.element is the item under the pointer in the destination list
      const candidate = evt?.relatedContext?.element || null;
      const isFolder = candidate?.attributes?.type === 'Board'  || candidate?.attributes?.type === 'Folder' || candidate?.attributes?.type === 'Album';
      this.hoveredContainer = isFolder ? candidate : null;
      return true; // allow move
    },
    getFolderFromPoint(originalEvent) {
      if (!originalEvent) return null;
      const { clientX, clientY } = originalEvent;
      const el = document.elementFromPoint(clientX, clientY);
      const wrapper = el?.closest?.('.container-tile[data-content-id]');
      if (!wrapper) return null;
      const id = wrapper.getAttribute('data-content-id');
      return this.container_list.find(i => String(i.id) === String(id)) || null;
    },
    onSourceDragStart(evt) {
      console.log("on source drag start")
      // source list still intact here
      this.draggedItem = this.noncontainer_list[evt.oldIndex]
      console.log("draggedItem", this.draggedItem)
      this.pre_draggable_container_list = JSON.parse(JSON.stringify(this.container_list))
    },
    async onAddToFolder(evt) {
    const prevContainerList = this.pre_draggable_container_list//JSON.parse(JSON.stringify(this.container_list))
    //const prevNoncontainerList = JSON.parse(JSON.stringify(this.noncontainer_list))

    //console.log('onAddToFolder', evt)
   // console.log(evt.newIndex)
    //console.log(evt.oldIndex)
    //console.log("folderList", this.container_list)
    //console.log("fileList", this.noncontainer_list)
    // 1) figure out which folder we dropped ONTO
   // console.log("prevContainerList", prevContainerList)
   // console.log("hoveredContainer", this.hoveredContainer )
   // console.log("getFolderFromPoint",  this.getFolderFromPoint(evt.originalEvent) )
   // console.log("pre_draggable", this.pre_draggable_container_list?.[evt.newIndex])
    //const folder = prevContainerList[evt.newIndex]
    let folder =
      this.hoveredContainer ||
      this.getFolderFromPoint(evt.originalEvent) ||
      this.pre_draggable_container_list?.[evt.newIndex]; // last resort
      if ( folder.attributes?.type == 'Folder' || folder.attributes?.type == 'File'){
        folder =  this.pre_draggable_container_list?.[evt.newIndex]; // last resort
      }

    // 2) get the original dragged data
    // when we used pull:'clone', the item is cloned and inserted here.
    // we can grab it from evt.clone or from container_list[evt.newIndex]
    const droppedItem =   this.draggedItem //prevNoncontainerList[evt.oldIndex]
    //console.log("evt", evt)
    // 3) immediately remove the inserted clone so the folder list looks unchanged

    console.log("folder", folder)
    console.log("droppedItem", droppedItem)
   // this.pre_draggable_container_list = []
    //this.draggedItem = null 
    // safety
    if (!folder || (folder.attributes?.type !== 'Board' && folder.attributes?.type !== 'Folder' && folder.attributes?.type !== 'Album') || !droppedItem) return

    const shareId =
      droppedItem.relationships &&
      droppedItem.relationships['context-share'] &&
      droppedItem.relationships['context-share'].data &&
      droppedItem.relationships['context-share'].data.id
    console.log("folder id" + folder.id)
    console.log("item id" + droppedItem.id)
    console.log("shareid" + shareId)
    if (shareId) {
      // your existing action
      console.log("moving...")
      await this.moveContent({
        shareId,
        destinationId: folder.id,
        destinationType: 'Container'
      })
      this.container_list.splice(evt.newIndex, 1)
    }
  },
    draggableGroup(e){
      console.log(e)
      if (e.attributes["type"] == "Folder"){
        return  { name: 'widgets', pull: false, put: true }
      } else {
        return { name: 'widgets', pull: 'clone', put: false }
      }
    },

    /*onDragStart(evt) {
      this.drag = true; // Set drag state to true when dragging starts
      console.log("Drag started:", evt);
    },
    async onDragEnd(evt) {
      this.drag = false; // Reset drag state
      console.log("Drag ended:", evt);
      console.log(evt)
      console.log(evt.oldIndex)
      console.log(evt.newIndex)
      const movedTo = this.container_list[0];//this.sortedContents(this.filteredContents)[evt.oldIndex];
      const movedItem = this.noncontainer_list[evt.newIndex];//this.sortedContents(this.filteredContents)[evt.newIndex];
      console.log(movedTo.id)
      console.log(movedItem)
      console.log(movedTo)
      console.log(movedItem.relationships['context-share'].data.id)
      console.log("movedto:" + movedTo.attributes['type'])
      console.log("movedItem:" + movedItem.attributes['type'])
      if (movedTo.attributes["type"] == "Folder"){
        console.log("Moving!!")
        await this.moveContent({shareId: movedItem.relationships['context-share'].data.id, destinationId: movedTo.id, destinationType: "Container"})
        //window.location.reload();
      }
      // Example: Handle moved item
      //const movedItem = this.rallyListing[evt.oldIndex];
      //const replacedItem = this.rallyListing[evt.newIndex];
      //await this.handleItemMoved(evt.oldIndex, evt.newIndex, movedItem, replacedItem);
    },*/
    debugFolderFetch() {
      console.log('=== Debug Folder Fetch ===');
      console.log('Channel:', this.channel);
      console.log('Channel ID:', this.channelId);
      console.log('Channel Type:', this.channelType);
      console.log('Channel Slug:', this.channelSlug);
      console.log('Is Files channel?', this.channelType === 'Files');
      console.log('Current folder structure in store:', this.folderStructure);
      console.log('=========================');
    },
    async fetchFolderStructureForChannel() {
      // Only fetch if we're in the Files channel
      console.log("maybe fetching structure...")
      if (this.channelType !== 'Files') {
        console.log('Not fetching folders - channel type is:', this.channelType);
        return;
      }

      console.log('Fetching folder structure for channel:', this.channelId);

      try {
        await this.fetchFoldersRecursive({
          contextRallyId: this.rallyId,
          contextChannelId: this.channelId,
          contextId: this.channelId,
          contextType: 'Channel',
          nestLevel: 1,
          result: []
        });
        console.log('Folder structure fetched successfully');
      } catch (error) {
        console.error('Error fetching folder structure:', error);
      }
    },
    // ENHANCED: Fixed infinite scroll methods


    checkIfNeedMoreContent($state) {
      setTimeout(() => {
        const contentArea = this.$refs.contentArea;//this.$el.querySelector('.content-area');
        if (contentArea) {
          const viewportHeight = window.innerHeight;
          const contentHeight = contentArea.offsetHeight;
          const totalCount = this.totalCount;
          const currentCount = this.contents ? this.contents.length : 0;
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          //console.log(`Scroll position: ${scrollTop}px, Viewport: ${viewportHeight}px, Content: ${contentHeight}px, Items: ${currentCount}/${totalCount}`);

          if (contentHeight < (viewportHeight * 1.5) && currentCount < totalCount && !this.isLoadingComplete) {
            console.log("Content doesn't fill screen adequately, loading more...");
            setTimeout(() => {
              this.infiniteHandler($state);
            }, 100);
          }
        }
      }, 200);
    },

    async loadPageData() {
      if (!this.channelId) return;

      try {
        this.loadAttempted = true;
        this.clearContentByContextId({ contextId: this.channelId });

        const initialParams = {
          ...this.contentParams,
          ignorePagination: true,
          ignoreCache: true,
          pageNumber: 1
        };

        if (this.channelType === 'Payables') {
          // For Payables, we want to load both active and draft contents
          await this.fetchContents(initialParams);
          initialParams['status'] = "0";
          initialParams['creatorId'] = userInfo().id; // Only fetch drafts created by the user
          await this.fetchContents(initialParams);
        } else {
          await this.fetchContents(initialParams);
        }
      //  console.log("Loading initial page data with params:", initialParams);


        // After loading content, fetch folder structure if needed
        if (this.channelType === 'Files') {
          await this.fetchFolderStructureForChannel();
        }

      } catch (error) {
        console.error("Error loading page data:", error);
      }
    },

    startUploadProgressMonitoring() {
      this.uploadProgressInterval = setInterval(() => {
        this.updateUploadQueueStatus();
      }, 100);
    },

    updateUploadQueueStatus() {
      this.uploadQueueStatus.isProcessing = uploadQueue.state.isProcessing;
      this.uploadQueueStatus.totalFiles = uploadQueue.state.totalFiles;
      this.uploadQueueStatus.completedFiles = uploadQueue.state.completedFiles;
      this.uploadQueueStatus.activeCount = uploadQueue.getActiveCount();
      this.uploadQueueStatus.queueLength = uploadQueue.getQueueLength();
      this.uploadQueueStatus.progress = uploadQueue.getProgress();
      this.uploadQueueStatus.activeUploads = uploadQueue.getActiveUploads();
      this.uploadQueueStatus.remainingFiles = uploadQueue.getRemainingFiles();
    },

    truncateFileName(fileName) {
      if (fileName.length <= 25) return fileName;
      const ext = fileName.split('.').pop();
      const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
      const truncatedName = nameWithoutExt.substring(0, 20);
      return `${truncatedName}...${ext}`;
    },

    reloadPage(){
      location.reload()
    },
    newContentFilter(cs) {
      if (!cs || cs.length === 0) return [];
      if ((cs[0].attributes['content-type'] === 'Message')){
        return this.sortedContents(cs)
      }
      return cs.filter(content => content && !content.id);
    },
    notNewContentFilter(cs) {
      if (!cs || cs.length === 0) return [];
      return cs.filter(content => content && content.id);
    },



    sortedContents(cs) {
      if (
        cs &&
        cs.length > 0 &&
        (
          cs[0].attributes['content-type'] === 'Fundraiser' ||
          cs[0].attributes['content-type'] === 'Event'
        )
      ) {
        return cs.sort((a, b) => {
          const aDate = a.attributes['converted-start']
          const bDate = b.attributes['converted-start']

          // Blank dates go to the top
          if (!aDate && bDate) return -1
          if (aDate && !bDate) return 1
          if (!aDate && !bDate) return 0

          // Both have dates → normal ascending sort
          return new Date(aDate) - new Date(bDate)
        })
      }

      return cs
    },


    async triggerBatchSentimentFetch() {
      // Collect all shareIds from current content
      const shareIds = new Set();

      if (this.filteredContents && this.filteredContents.length > 0) {
        this.filteredContents.forEach(content => {
          // Check if content has a share relationship
          if (content.relationships &&
              content.relationships['context-share'] &&
              content.relationships['context-share'].data &&
              content.relationships['context-share'].data.id) {
            // Store as string for consistency
            shareIds.add(String(content.relationships['context-share'].data.id));
          }
        });
      }

      // If we have shareIds, fetch all sentiments in one batch
      if (shareIds.size > 0) {
        const shareIdArray = Array.from(shareIds);
        //console.log(`Fetching sentiments for ${shareIdArray.length} items in batch`);
        await this.fetchContentsLikeCounts({ shareIds: shareIdArray });
      }
    },

    closeModal(){
      this.setNoSearchResultsFlag({flag:false})
    },

    closeFileLimitModal(){
      this.fileLimitUploads = false;
    },

    async handleContentFilterChange(status) {
      let filterParams = { ...this.contentParams };
      filterParams['ignorePagination'] = true
      filterParams['status'] = status
      if(parseInt(status) == 0){
        filterParams['creatorId'] = userInfo().id
      }
      if(parseInt(status) == 2) {
        filterParams['creatorId'] = userInfo().id
      }
      if(parseInt(status) == 3) {
        filterParams['status'] = 1
        filterParams['childContentParticipantId'] = userInfo().id
      }

      this.clearContentByContextId({contextId: this.channelId})
      if(parseInt(status) == 1 && this.channelType == "Payables") {
        console.log("ChANLE TYPE: " + this.channelType)
        console.log(this.channelType)
        // Get Active contents
        console.log("fetching active contents!!!!!!!!!!!!!!!!!!!!!!!")
        await this.fetchContents(filterParams);
        // And then also get Drafts

        filterParams['creatorId'] = userInfo().id;
        filterParams['status'] = "0"
        console.log("fetching draft contents!!!!!!!!!!!!!!!!!!!!!!!")
        console.log(filterParams)
        this.fetchContents(filterParams);
      }
      else {
        this.fetchContents(filterParams);
      }
    },

    myReloadPageData() {
      this.uploadProgress = 30;
      this.pageMap[this.myType] = 1;
    },

    myFetchContents(){
      console.log("my fetching contents")
      if (this.isChildContent){
        this.fetchContentById({
              id: this.contextId,
              contextRallyId: this.rallyId,
              contentType: "Container"
        })
      }
      this.fetchContents(this.contentParams);
    },

    cancelNewInline() {
      this.contents.shift();
    },

    showLightbox(image) {
      this.currentPhoto = image;
    },

    handleLightboxHide() {
      this.currentPhoto = null;
    },

    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting}) => {
        if (!isIntersecting) {
          return;
        }

        let contentId = target?.attributes?.contentid?.value;
        let contentType = target?.attributes?.contenttype?.value;

        if (contentId && contentType){
          let params = {}
          params['contentId'] = contentId
          params['contentType'] = contentType
          params['actionType'] = 'viewed'
          params['rallyId'] = this.rallyId
          params['userId'] = userInfo()['id']
          this.contentViewed(params);
        }
      })
    },

    onFileUpload(e) {
      if (e.target.files.length > 50){
        alert("You can only upload up to 50 files at a time.");
        return;
      }
      this.queueFilesForUpload(e.target.files, "File");
    },

    onImageUpload(e) {
      if (e.target.files.length > 50){
        alert("You can only upload up to 50 photos at a time.");
        return;
      }
      this.queueFilesForUpload(e.target.files, "Photo");
    },

    queueFilesForUpload(files, type) {
      const uploadFunction = (params) => {
        return this.uploadFilez(params.fileData, type, params);
      };

      const baseParams = {
        contentType: "Binary",
        contextId: this.contextId,
        contextType: this.contextType,
        type,
        contextChannelId: this.channelId,
        rallyId: this.rallyId,
        contextRallyId: this.rallyId,
      };

      uploadQueue.addToQueue(files, uploadFunction, baseParams);
    },

    showFilez() {
      this.$refs.filePicker.click(); 
    },

    showImagez() {
      this.$refs.imagePicker.click();
    },
    async loadNextPage(){
      // --- Check to see if we are loading contents within a container
      // --- If so, we need to fetch the contents of the container
      if (!this.channelId){
        console.log("fetching channels")
        await this.fetchRalliesChannels({rallyId: this.rallyId})
      }
      if(this.isChildContent) {
        console.log("fetching child contents")
        await this.fetchContents({
          contextType: "Container",
          contextChannelId: this.channelId,
          //rallyId: this.rallyId,
          //contextRallyId: this.rallyId,
          contextId: this.contextId,//this.parentContainers[this.parentContainers.length - 1].id,
          contentType: ["Binary", "Link", "Container", "Event", "Attachment"],
          customPageSize: ["Files", "Links", "Gallery", "Payables", "Signups"].includes(this.channelType) ? 15 : 10
        });
      } else {
        // --- Otherwise just fetch the next page of the channel
        console.log("regular contents fetch")
        await this.fetchContents({
          ...this.contentParams
        })
      }
      this.content_list = this.sortedContents(this.filteredContents)
      this.noncontainer_list = this.sortedContents(this.filteredNonContainers)
      this.container_list = this.sortedContents(this.filteredContainers)
    },
    async infiniteHandler($state) {
      let beforesize = this.contents ? this.contents.length : 0
      //console.log("Infinite scroll triggered, current items:", beforesize)

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop < 100 && beforesize === 0) {
        //console.log("Near top with no content, likely a fresh folder load");
      }

      try {
        await this.loadNextPage();

        let aftersize = this.contents ? this.contents.length : 0
        //console.log("After loading, items:", aftersize)

        if (beforesize === aftersize) {
         // console.log("No new content loaded - completing infinite scroll")
          $state.complete();
        } else {
          //console.log("New content loaded - continuing infinite scroll")
          $state.loaded();

          this.$nextTick(() => {
            this.checkIfNeedMoreContent($state);
          });
        }
      } catch (error) {
        console.error("Error in infinite handler:", error);
        $state.error();
      }
    },

    followLink(theUrl) {
      window.open(theUrl, "_blank");
    },

    navUp() {
      if (this.$route.path.indexOf("/c/") > 0){
        window.history.back()
        /*const segments = this.$route.path.split('/').filter(Boolean) // remove empty strings
        let trimmedSegments = segments.slice(0, -1) // remove last segment
        if (trimmedSegments.slice(0,-1) == "c"){
            trimmedSegments = trimmedSegments.slice(0, -1) // remove last segment
        }
        const newPath = '/' + trimmedSegments.join('/')
        router.push(newPath);*/
      }  else {
        const path = `/${this.rallyId}/${this.channelSlug}`;
        router.push(path);
      }
    },
    newInline(params) {
      if (!this.contents){
        this.contents = []
      }
      if (params.contentType == "SignupEvent"){
            console.log("signup!")
            let params = {}
            params['type'] = 'SignupEvent'
            params['contentType'] = 'Event'
            params['contextType'] = 'Channel'
            params['contextChannelId'] = this.channelId
            params['contextId'] = this.channelId
            params['rallyId'] = this.rallyId
            params['contextRallyId']= this.rallyId
            params['maxParticipants'] = '1'
            params['privacy'] = "1"
            params['title'] = ''
            params['status'] = "0"
            params['editMode'] = true
            if (this.isChildContent) {
              console.log("child signup")
              params["contextId"] = this.contextId//this.parentContainers[0].id
              params["contextType"] = this.contextType

            }
            try {
              this.createContents(params)
            } catch (e) {
              console.log(e)
            }

      } else {
        this.contents.unshift({
          editMode: true,
          attributes: {
            type: params.contentType,
            lifecycle: "new",
            status: 0,
            editable: true,
            deleteable: true
          }
        });
      }
    },
    async openContainer(c) {
      console.log(".....open container")
      const containerId = c.id ? c.id : c
      this.clearContentSearchResults({})
      //alert(containerId)
      //this.parentContainers.push(container);
      //this.parentContextIds.push(this.contextId);
      //this.parentContextTypes.push(this.contextType);
      //this.contextId = containerId;
      //this.contextType = "Container"
      //this.clearContentByContextId({contextId: containerId})
      let fetchParams = {
        contextType: "Container",
        rallyId: this.rallyId,
        contextRallyId: this.rallyId,
        contextChannelId: this.channelId,
        contextId: containerId,
        contentType: ["Binary", "Link", "Container", "Event", "Attachment"],
        pageNumber: 1,
        customPageSize: ["Files", "Links", "Gallery", "Payables", "Signups"].includes(this.channelType) ? 15 : 10
      }
      if(c?.attributes?.type == "SignupList"){
        fetchParams['excludeParticipations'] = true
      }
      //alert ("fetching....")
      await this.fetchContents(fetchParams);

    },
    openContent(content) {
      console.log("....open content")
      const contentId = content.id;
      this.openContainer(content);
      let path = `/${this.rallyId}/${this.channelSlug}/${contentId}`;
      if (this.channelSlug.indexOf("?") > -1){
        let channelSlugBase = this.channelSlug.split('?')[0]
        let channelSlugParams = this.channelSlug.split('?')[1]
        path = `/${this.rallyId}/${channelSlugBase}/${contentId}?${channelSlugParams}`;
      }
      router.push(path);
      if (this.loadPageData) {
        this.loadPageData();
      }
    },
    newContent() {
      const path = `/${this.rallyId}/${this.newAction}`;
      router.push(path);
    },

    perform(method, params) {
      params ? this[method](params) : this[method]();
    },
    goToContent(c) {
      console.log("sci gotocontent!")
        const currentPath = this.$route.path;
        if (currentPath.indexOf("/c/") < 0){
          router.push(`${currentPath}/c/${c.id}`);
        } else {
          router.push(`${currentPath}/${c.id}`);
        }
        console.log("emitting openContainer")
        this.$emit('perform', 'openContainer', c);
    },
    clearParentContainers() {
      this.parentContainers = []
      this.parentContextIds = []
      //this.contextId =
      this.contextType = "Channel"
      this.clearContentByContextId({contextId: this.channelId})
    },
    saveNewInline(p) {
      this.contents.shift();

      var params = {
        contentType: p.contentType,
        contextId: this.contextId,
        contextType: this.contextType,
        type: p.type,
        contextChannelId: this.channelId,
        contextRallyId: this.rallyId,
        rallyId: this.rallyId,
        status: (p.status === undefined) ? 1 : p.status
      }
      if (p.rallyId){
        params['rallyId'] = p.rallyId
      }
      if (p.title){
        params['title'] = p.title
      }
      if (p.description){
        params['description'] = p.description
      }
      if (p.maxParticipants){
        params['maxParticipants']= p.maxParticipants
      }
      if (p.url){
        params['url'] = p.url
      }
      if (p['update-all']) {
        params['update-all'] = p.update_all
      }
      //Parameters: {"data"=>{"type"=>"contents", "attributes"=>{"content_type"=>"Container", "context_id"=>"290812", "context_type"=>"Channel", "title"=>"FOLDA", "type"=>"Album", "context_channel_id"=>"290812", "context_rally_id"=>"38720", "creator_id"=>303137, "status"=>1, "include"=>"creator,creator_avatar"}}}
      if (this.isChildContent) {
        //if it's a subfolda then do this...
        params["contextId"] = this.contextId;
        params["contextType"] = "Container";
      }
      this.createContents(params);
    },

    displayUploadProgress() {
      setTimeout(
          function() {
            if (this.uploadCount > 0) {
              if (this.uploadProgress > 90){
                this.uploadProgress = 30
              }
              this.uploadProgress += 1;
              this.displayUploadProgress();
            }
          }.bind(this),
          100
      );
    },

    uploadPhoto(img) {
      var params = {
        contentType: "Binary",
        contextId: this.contextId,
        contextType: "Channel",
        type: "Photo",
        contextChannelId: this.channelId,
        contextRallyId: this.rallyId,
        rallyId: this.rallyId,
        attachment: img.dataUrl.split(",")[1],
        attachmentContentType: img.info.type,
        attachmentFileName: img.info.name,
        fileData: img,
      };
      if (this.isChildContent) {
        //if it's a subfolda then do this...
        params["contextId"] = this.contextId;
        params["contextType"] = "Container";
      }
      this.uploadFile(params);
      this.displayUploadProgress();
    },

    uploadFilez(f, type= "File", additionalParams = {}) {
      var reader = new FileReader();
      reader.onload = e => {
        var params = {
          contentType: "Binary",
          contextId: this.contextId,
          contextType: this.contextType,
          type,
          contextChannelId: this.channelId,
          rallyId: this.rallyId,
          contextRallyId: this.rallyId,
          attachment: reader.result.split(",")[1],
          attachmentContentType: f.type,
          attachmentFileName: f.name,
          fileData: f,
          ...additionalParams // Merge any additional params
        };
        if (this.isChildContent) {
          //if it's a subfolda then do this...
          params["contextId"] = this.contextId;
          params["contextType"] = "Container";
        }
        // Don't call displayUploadProgress here since queue manages progress
        return this.uploadFile(params);
      };

      // Return a promise for the queue
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onload = async (e) => {
          try {
            var params = {
              contentType: "Binary",
              contextId: this.contextId,
              contextType: this.contextType,
              type,
              contextChannelId: this.channelId,
              rallyId: this.rallyId,
              contextRallyId: this.rallyId,
              attachment: reader.result.split(",")[1],
              attachmentContentType: f.type,
              attachmentFileName: f.name,
              fileData: f,
              ...additionalParams
            };
            if (this.parentContextIds && this.parentContextIds.length > 0) {
              params["contextId"] = this.contextId;
              params["contextType"] = "Container";
            }
            await this.uploadFile(params);
            resolve();
          } catch (error) {
            reject(error);
          }
        };

        try {
          reader.readAsDataURL(f);
        } catch (e) {
          console.log(e);
          reject(e);
        }
      });
    },

    moveFolderInParent(destinationFolderId) {
      console.log('Move folder in parent:', destinationFolderId);
    }
  }
};
</script>

<style scoped>
/* Ensure smooth scrolling behavior */
html {
  scroll-behavior: smooth;
}

/* Make sure content area has proper spacing */
.content-area {
  padding-bottom: 50px; /* Add some bottom padding for infinite scroll trigger */
}

/* Style for loading states */
.fa-spinner {
  font-size: 20px;
  color: #007bff;
}

.fa-sync {
  font-size: 16px;
  color: #6c757d;
  transition: transform 0.3s ease;
}

.fa-sync:hover {
  transform: rotate(180deg);
  color: #007bff;
}
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

</style>